import { Injectable } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { CustomValidators } from 'projects/ppb-shared-library/src/lib/services/form/custom-validators';

@Injectable({ providedIn: 'root' })
export class PpbAccountDataFormBuilder {

  constructor(
    private fb: UntypedFormBuilder) {
  }

  getAccountUpdateForm(): UntypedFormGroup {
    return this.fb.group(
      {
        firstName: new UntypedFormControl('', {
          validators: [Validators.required, CustomValidators.firstName(), CustomValidators.trimSpacesValidator('Niepoprawne imię')],
          updateOn: 'blur'
        }),
        lastName: new UntypedFormControl('', {
          validators: [Validators.required, CustomValidators.lastName(), CustomValidators.trimSpacesValidator('Niepoprawne nazwisko')],
          updateOn: 'blur'
        }),
        ial: new UntypedFormControl('', Validators.required),
        expectedIal: new UntypedFormControl('', Validators.required),
        email: new UntypedFormControl('', {
          validators: [Validators.required, CustomValidators.email()],
          updateOn: 'blur'
        }),
        phone: new UntypedFormGroup({
          number: new UntypedFormControl(null,
            {
              validators: [Validators.required, CustomValidators.phone()],
              updateOn: 'blur'
            }),
          prefix: new UntypedFormControl(null,
            {
              validators: [Validators.required],
              updateOn: 'blur'
            }),
        }),
        sharePhone: new UntypedFormControl(false)
      }
    )
  }

  getSMSConfirmForm(isPhoneChanged: boolean = null): UntypedFormGroup {
    const formGroup = this.fb.group(
      {
        currentPhoneSmsCode: new UntypedFormControl('', { validators: [Validators.required] })
      }
    );

    if (isPhoneChanged) {
      formGroup.addControl('newPhoneSmsCode', new UntypedFormControl('', {
        validators: [Validators.required]
      }))
    }
    return formGroup;
  }

  getRulesConfirmForm(): UntypedFormGroup {
    return this.fb.group(
      {
        rulesConfirmed: new UntypedFormControl(false, { validators: [Validators.required] })
      }
    )
  }

  getConfirmIdentityForm(validators: ValidatorFn[] = []): UntypedFormGroup {
    return this.fb.group(
      {
        documents: new UntypedFormControl('',),
        ial: new UntypedFormControl('', { validators: [Validators.required, ...validators] }),
      }
    )

  }
}
